export const sectorsList = [
  { value: '', label: '--Escoge una opción--' },
  { value: 'Consultancy Services', label: 'Consultancy Services' },
  { value: 'e-Commerce', label: 'e-Commerce' },
  { value: 'Education', label: 'Education' },
  { value: 'e-Learning', label: 'e-Learning' },
  { value: 'Financial Services', label: 'Financial Services' },
  { value: 'Financial Technology', label: 'Financial Technology' },
  { value: 'Gambling', label: 'Gambling' },
  { value: 'Multilevel Marketing', label: 'Multilevel Marketing' },
  { value: 'Others', label: 'Others' },
  { value: 'Saas', label: 'Saas' },
  { value: 'Sports Betting', label: 'Sports Betting' },
  { value: 'Technology provider', label: 'Technology provider' },
  { value: 'Ticketing', label: 'Ticketing' },
  { value: 'Tourism', label: 'Tourism' },
  { value: 'Travel', label: 'Travel' }
];